<script setup lang="ts">
import { BaseValidation } from '@vuelidate/core'
import { classNameForInvalidFields } from '@/validation'
import ValidationErrors from '@/components/input/ValidationErrors.vue'

const props = defineProps<{
  label?: string
  validation?: BaseValidation
  required?: boolean
  hint?: string
}>()
</script>

<template>
  <div :class="`form-field ${props.validation?.$invalid ? classNameForInvalidFields : ''}`">
    <div v-if="props.label || props.hint" class="label">
      <label v-if="!!props.label">{{ props.label }}</label>
      <span v-if="props.required" class="text-error">*</span>
      <v-tooltip v-if="props.hint" location="top" max-width="250">
        <template #activator="{ props: tooltipProps }">
          <v-icon
            v-bind="tooltipProps"
            icon="info"
            size="small"
            class="ml-1"
            style="opacity: 0.6"
          />
        </template>
        <div style="white-space: normal; line-height: 1.4">{{ props.hint }}</div>
      </v-tooltip>
    </div>
    <div>
      <slot name="default" />
    </div>
    <validation-errors :validation="props.validation" />
  </div>
</template>

<style lang="scss">
.form-field {
  margin-bottom: 1rem;

  .label {
    font-size: 0.95em;
    margin-bottom: 3px;
  }
}
</style>
